import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { CheckboxField } from 'Shared/form/CheckboxField';
import { CheckboxMultiField } from 'Shared/form/CheckboxMultiField';
import { setWorkQueueFilterGenerator } from '../../workQueue.utils';
import AccordionWrapper from 'App/components/AccordionWrapper/AccordionWrapper';
import HeaderContent from '../HeaderContent';
import ExcludeToggleFilter from './ExcludeToggleFilter';

const ActivityMultiSelectFilter = () => {
    const {
        values: { filterParams, allActivityTypesList, allCustomOptionsList },
        setFieldValue,
    } = useFormikContext();
    const setWorkQueueFilter = setWorkQueueFilterGenerator(setFieldValue);
    const { filters, excludeActivityTypes } = filterParams;

    const selectedCustomOptionsCount = (allCustomOptionsList || []).filter((opt) => filterParams[opt.id]).length;
    const selectedCount = filters.length + selectedCustomOptionsCount;
    const totalCount = (allActivityTypesList || []).length + (allCustomOptionsList || []).length;
    const isExcludeDisabled = !selectedCount || selectedCount === totalCount;

    useEffect(() => {
        setWorkQueueFilter(filterParams, 'allTypes', filters?.length === allActivityTypesList.length);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters]);

    useEffect(() => {
        if (isExcludeDisabled && excludeActivityTypes) {
            setFieldValue('filterParams.excludeActivityTypes', false);
        }
    }, [isExcludeDisabled, excludeActivityTypes, setFieldValue]);

    return (
        <AccordionWrapper
            title="Activity Filter"
            stateKey="workQueueActivityFilter-toggle"
            HeaderContent={HeaderContent}
            headerClassName="accordion-header-h4-title"
        >
            <div className="multi-select-spacing-filter">
                <ExcludeToggleFilter
                    fieldName="filterParams.excludeActivityTypes"
                    disabled={isExcludeDisabled}
                    onChange={(checked) => setWorkQueueFilter(filterParams, 'excludeActivityTypes', checked, true)}
                />
                <CheckboxMultiField
                    fieldName="filterParams.filters"
                    className="spacing-multi-checkboxes"
                    options={allActivityTypesList}
                    onChange={(values) => setWorkQueueFilter(filterParams, 'filters', values, true)}
                />
                {allCustomOptionsList.map((opt, index) => (
                    <CheckboxField
                        key={opt.id}
                        fieldName={`filterParams.${opt.id}`}
                        className={index === 0 ? 'spacing-following-checkbox' : ''}
                        label={opt.option}
                        onChange={(e) => setWorkQueueFilter(filterParams, opt.id, e.target.checked, true)}
                    />
                ))}
            </div>
        </AccordionWrapper>
    );
};

export default ActivityMultiSelectFilter;
